export default "__VITE_ASSET__242fe7ce__"